import { useState, useEffect } from 'react';
import api from '../lib/api';

const VAPID_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map(c => c.charCodeAt(0)));
}

export function usePushNotifications() {
  const [permission, setPermission] = useState(
    typeof Notification !== 'undefined' ? Notification.permission : 'default'
  );
  const [subscription, setSubscription] = useState(null);
  const [supported] = useState('serviceWorker' in navigator && 'PushManager' in window && !!VAPID_KEY);

  useEffect(() => {
    if (!supported) return;
    navigator.serviceWorker.ready.then(reg => {
      reg.pushManager.getSubscription().then(sub => {
        if (sub) setSubscription(sub);
      });
    });
  }, [supported]);

  const subscribe = async (teamId, playerIds = [], username = '') => {
    if (!supported) return null;
    const perm = await Notification.requestPermission();
    setPermission(perm);
    if (perm !== 'granted') return null;
    const reg = await navigator.serviceWorker.ready;
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_KEY)
      });
    }
    setSubscription(sub);
    const subJSON = sub.toJSON();
    await api.post('/push/subscribe', {
      endpoint: subJSON.endpoint,
      keys: subJSON.keys,
      team_id: teamId,
      player_ids: playerIds,
      username
    });
    return sub;
  };

  const unsubscribe = async () => {
    if (subscription) {
      const subJSON = subscription.toJSON();
      await api.post('/push/unsubscribe', { endpoint: subJSON.endpoint, keys: subJSON.keys });
      await subscription.unsubscribe();
      setSubscription(null);
    }
  };

  return { permission, subscription, supported, subscribe, unsubscribe };
}
